export default "__VITE_ASSET__D1ph0oXX__"